import { render, staticRenderFns } from "./vicinityPage.vue?vue&type=template&id=94d0971c&scoped=true&"
import script from "./vicinityPage.vue?vue&type=script&lang=js&"
export * from "./vicinityPage.vue?vue&type=script&lang=js&"
import style0 from "./vicinityPage.vue?vue&type=style&index=0&id=94d0971c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d0971c",
  null
  
)

export default component.exports